/* Handora: one card in the initial product HTML; store-time delivery estimates. */
(function () {
  'use strict';
  var CRAFT_MIN = 2, CRAFT_MAX = 3, TRANSIT_MIN = 7, TRANSIT_MAX = 10;
  var DAY = 86400000;
  /* Only touch the DOM when the visible text actually changes (avoids per-second style recalcs). */
  function setText(el, v) {
    if (!el || el.textContent === v) return;
    var f = el.firstChild;
    if (f && f.nodeType === 3 && el.childNodes.length === 1) f.nodeValue = v; else el.textContent = v;
  }
  function storeDay(now, zone) {
    var parts = new Intl.DateTimeFormat('en-US', {timeZone: zone, year:'numeric',month:'numeric',day:'numeric'}).formatToParts(now);
    var p = {};
    parts.forEach(function (part) { p[part.type] = part.value; });
    return new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day)));
  }
  function addDays(date, n) { return new Date(date.getTime() + n * DAY); }
  function businessDays(date, n) {
    var d = date;
    while (n > 0) { d = addDays(d, 1); if (d.getUTCDay() !== 0 && d.getUTCDay() !== 6) n--; }
    return d;
  }
  function format(date, options) {
    return date.toLocaleDateString('en-US', Object.assign({timeZone:'UTC'}, options));
  }
  function range(a, b, year) {
    var options = {month:'short',day:'numeric'};
    if (a.getUTCFullYear() !== year || b.getUTCFullYear() !== year) options.year = 'numeric';
    if (a.getTime() === b.getTime()) return format(a, options);
    if (a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear()) {
      return format(a, {month:'short',day:'numeric'}) + '–' + b.getUTCDate() + (options.year ? ', ' + b.getUTCFullYear() : '');
    }
    return format(a, options) + ' – ' + format(b, options);
  }
  function estimate(day) {
    var a = businessDays(day, CRAFT_MIN), b = businessDays(day, CRAFT_MAX);
    return {shipA:a,shipB:b,arrivalA:addDays(a,TRANSIT_MIN),arrivalB:addDays(b,TRANSIT_MAX)};
  }
  function windowKey(day) { var e = estimate(day); return e.arrivalA.getTime() + ':' + e.arrivalB.getTime(); }
  function lastOrderDay(day) {
    var key = windowKey(day), d = day;
    for (var i = 1; i <= 7; i++) { if (windowKey(addDays(day, i)) !== key) break; d = addDays(day, i); }
    return d;
  }
  /* Convert a store calendar midnight to an instant, including DST changes. */
  function storeMidnight(day, zone) {
    var target = day.getTime(), instant = target;
    for (var i = 0; i < 3; i++) {
      var parts = new Intl.DateTimeFormat('en-US', {timeZone:zone,year:'numeric',month:'numeric',day:'numeric',hour:'numeric',minute:'numeric',second:'numeric',hourCycle:'h23'}).formatToParts(new Date(instant));
      var p = {};
      parts.forEach(function (part) { p[part.type] = part.value; });
      var wall = Date.UTC(+p.year,+p.month-1,+p.day,+p.hour,+p.minute,+p.second);
      instant += target - wall;
    }
    return instant;
  }
  function holiday(day, zone, season) {
    if (season !== 'halloween') return null;
    var holidayDay = new Date(Date.UTC(day.getUTCFullYear(), 9, 31));
    if (day > holidayDay || estimate(day).arrivalB > holidayDay) return null;
    for (var i = 1; i <= 90; i++) {
      var next = addDays(day, i);
      if (estimate(next).arrivalB > holidayDay) {
        if (i > 3) return null;
        return {at:storeMidnight(next,zone),last:addDays(next,-1),title:'Get it by Halloween'};
      }
    }
    return null;
  }
  function explicitCutoff(value) {
    /* Unzoned date strings depend on the visitor's clock: reject them. */
    if (!value || !/T.*(?:Z|[+-]\d{2}:\d{2})$/i.test(value)) return null;
    var at = Date.parse(value);
    return Number.isFinite(at) ? at : null;
  }
  function boot(card) {
    if (card.dataset.hdReady) return;
    card.dataset.hdReady = '1';
    var zone = card.dataset.timezone;
    var title = card.querySelector('[data-hd-title]'), sub = card.querySelector('[data-hd-sub]');
    var clock = card.querySelector('[data-hd-clock]');
    var dialog = card.querySelector('dialog'), opener = card.querySelector('[data-hd-open]');
    var previousOverflow = '', closing = false, timer;
    function tick() {
      if (!card.isConnected) { clearInterval(timer); if (dialog.open) dialog.close(); dialog.remove(); return; }
      var now = new Date(), day = storeDay(now, zone), e = estimate(day);
      var year = day.getUTCFullYear();
      var arrives = range(e.arrivalA, e.arrivalB, year), ships = range(e.shipA,e.shipB,year);
      [['placed',format(day,{month:'long',day:'numeric'})],['ships',ships],['arrival',arrives]].forEach(function(pair){
        var cell=dialog.querySelector('[data-hd-eta="'+pair[0]+'"]');setText(cell,pair[1]);
      });
      var last = lastOrderDay(day);
      var cutoff = card.dataset.cutoff ? null : holiday(day,zone,card.dataset.season);
      var configured = explicitCutoff(card.dataset.cutoff);
      if (configured && configured > now.getTime()) cutoff = {at:configured,title:card.dataset.cutoffTitle || 'Order before the cutoff',sub:card.dataset.cutoffSub};
      var active = cutoff && cutoff.at > now.getTime();
      card.classList.toggle('has-countdown', Boolean(active));
      if (clock.hidden !== !active) clock.hidden = !active;
      setText(title, active ? cutoff.title : 'Arrives ' + arrives);
      var fragment = document.createDocumentFragment();
      fragment.appendChild(document.createTextNode('Order by '));
      if (active) {
        var copy = cutoff.sub || format(cutoff.last || storeDay(new Date(cutoff.at-1),zone), {weekday:'short',month:'short',day:'numeric'});
        /* Custom subtitle is full merchant-authored text, never interpreted as HTML. */
        if (cutoff.sub) fragment = document.createTextNode(copy);
        else fragment.appendChild(document.createTextNode(copy));
      } else {
        var bold = document.createElement('b');
        bold.textContent = last.getTime() === day.getTime() ? 'Tonight' : format(last,{weekday:'long'});
        fragment.appendChild(bold);
        fragment.appendChild(document.createTextNode(' · ships ' + ships));
      }
      if (active) {
        var desktop = document.createElement('span'); desktop.className = 'hd-bp__desktop';
        desktop.textContent = ' · arrives ' + arrives;
        /* Inline on desktop to keep the delivery row at two lines. */
        desktop.style.display = '';
        var wrap = document.createElement('span'); wrap.className = 'hd-bp__cutoff-copy';wrap.appendChild(fragment);wrap.appendChild(desktop);fragment = wrap;
      }
      var subKey = (active ? '1|' : '0|') + fragment.textContent;
      if (sub.__hoKey !== subKey) { sub.__hoKey = subKey; sub.replaceChildren(fragment); }
      if (active) {
        var seconds = Math.max(0,Math.floor((cutoff.at-now.getTime())/1000));
        var values = [Math.floor(seconds/86400), Math.floor(seconds/3600)%24, Math.floor(seconds/60)%60, seconds%60];
        ['days','hours','minutes','seconds'].forEach(function (key,i) {setText(card.querySelector('[data-hd-'+key+']'), String(values[i]).padStart(2,'0'));});
      }
    }
    /* Native showModal supplies top-layer rendering, focus containment and inert background. */
    document.body.appendChild(dialog);
    function restore() {
      document.documentElement.style.overflow = previousOverflow;
      opener.setAttribute('aria-expanded','false');
      if (opener.isConnected) opener.focus({preventScroll:true});
      dialog.classList.remove('is-closing'); closing = false;
    }
    function close() {
      if (!dialog.open || closing) return;
      closing = true;dialog.classList.add('is-closing');
      var delay = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : (matchMedia('(min-width:990px)').matches ? 180 : 220);
      setTimeout(function () {dialog.close();},delay);
    }
    opener.addEventListener('click',function () {
      if (dialog.open) return;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();dialog.scrollTop=0;opener.setAttribute('aria-expanded','true');
    });
    dialog.addEventListener('close',restore);
    dialog.addEventListener('cancel',function (event) {event.preventDefault();close();});
    dialog.querySelectorAll('[data-hd-close]').forEach(function (button) {button.addEventListener('click',close);});
    var backdropDown = false;
    function outside(event) {var r=dialog.getBoundingClientRect();return event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom;}
    dialog.addEventListener('pointerdown',function (event) {backdropDown=outside(event);});
    dialog.addEventListener('click',function (event) {if(backdropDown&&outside(event))close();backdropDown=false;});
    tick();timer=setInterval(tick,1000);
  }
  function init() {document.querySelectorAll('[data-hd-bp]').forEach(boot);}
  init();document.addEventListener('shopify:section:load',init);
  // Quick View inserts product HTML after the initial page load.
  new MutationObserver(function(records){
    records.forEach(function(record){record.addedNodes.forEach(function(node){
      if(node.nodeType!==1)return;
      if(node.matches('[data-hd-bp]'))boot(node);
      node.querySelectorAll('[data-hd-bp]').forEach(boot);
    });});
  }).observe(document.body,{childList:true,subtree:true});
})();


